module.exports = __webpack_public_path__ + "static/media/header-hash.1a4e2cc0.svg";